"use strict";

var _regeneratorRuntime = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPrices = void 0;

var api_1 = require("../../api");

var notification_1 = require("../notification");

var actions_1 = require("./actions");

var fetchPrices = function fetchPrices(errorRetrievingPrice) {
  return function (dispatch) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0, api_1.apiRequest)('GET', "/products/prices");

            case 3:
              res = _context.sent;
              dispatch((0, actions_1.setPrices)(res));
              _context.next = 12;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
              dispatch((0, notification_1.addLabels)("new", {
                fetchValues: {
                  error: errorRetrievingPrice
                }
              }));
              dispatch((0, notification_1.setNotification)(notification_1.NotificationType.ERROR, notification_1.NotificationMessages.FETCH_VALUES_ERROR, "new"));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));
  };
};

exports.fetchPrices = fetchPrices;